<template>
  <nav class="align-items-center d-flex font-weight-light h4 justify-content-between mb-0 py-4">
    <ol class="breadcrumb mb-0">
      <li
        v-for="(item, index) in concatenatedItems"
        :key="index"
        class="breadcrumb-item"
        :class="{ active: index === concatenatedItems.length - 1 }"
      >
        <RouterLink
          v-if="index !== concatenatedItems.length - 1"
          :to="item.to!"
        >
          {{ item.text }}
        </RouterLink>
        <span v-else>
          {{ item.text }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";

interface BreadcrumbItem {
  text: string;
  to?: string;
}

const props = defineProps({ items: { required: true, type: Array as PropType<BreadcrumbItem[]> } });

const home: BreadcrumbItem[] = [{ text: "Início", to: "/home" }];

const concatenatedItems = computed(() => {
  return home.concat(props.items);
});
</script>
